export const makeNavbar = props => {
    return `display: flex;
          align-items: center;
          width: 100%;
          position: relative;
          height: 56px;
          @media (min-width: ${props.theme.screen.xlMin}){
            height: 72px;
          }`;
};
export const makeLinkNavbar = props => {
    return `width: 100%;
          text-align: center;
          display: inline-block;
          
          @media (min-width: ${props.theme.screen.xlMin}){
            width: auto;
          }`;
};
export const makeBrand = props => {
    return `display: block;
          position: absolute;
          top: 50%;
          left: 50px;
          right: 50px;
          transform: translate(0, -50%);
          text-align: center;
          &:focus,
          &:hover {
            text-decoration: none;
          }
          @media (min-width: ${props.theme.screen.xlMin}) {
            position: relative;
            top: auto;
            left: auto;
            right: auto;
            transform: none;
            margin-right: 24px;
          }
          img {
            display: block;
          }`;
};
export const makeBrandLink = () => {
    return `display: inline-block;
          vertical-align: middle;`;
};
export const makeToggle = () => {
    return ``;
};
export const makeCollapse = props => {
    const { visible } = props;
    return `width: 100%;
          background-color: white;
          
          @media (max-width: ${props.theme.screen.lgMax}) {
            position: fixed;
            z-index: 10;
            width: 100%;
            height: 100%;
            transition: left .3s ease-in-out;
            left: -100%;
            left: ${visible ? '0' : '-100'}%;
            top: 0;
          }`;
};
export const makeContent = props => {
    return `flex-basis: 100%;
          flex-grow: 1;
          align-items: center;
          justify-content: ${props.hideSearchBar ? `flex-end` : `space-between`};
          padding: 0px 16px;
          @media (min-width: ${props.theme.screen.xlMin}) {
            display: flex!important;
            flex-basis: auto;
            padding: 0;
          }`;
};
export const makeNavbarIcons = props => {
    return `display: inline-block;
          vertical-align: middle;
          width: 20px;
          height: 20px;
  
          &:before{
            width: 20px;
            height: 20px;
            @media (min-width: ${props.theme.screen.xlMin}){
              position: relative;
              display: none;
            }
          }`;
};
export const makeToggleNavbar = () => {
    return `width: 24px;
          height: 24px;
          line-height: 24px;
          text-align: center;
          border-radius: 50%;
          cursor: pointer;`;
};
